import React, { useEffect, useState, useCallback } from 'react'
import { LoanerInventoryDataGrid } from './LoanerInventoryDataGrid'
import { AddLoanerInventoryPane } from './AddLoanerInventoryPane'
import { useDispatch } from 'react-redux'
import * as components from '../../components'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'

export const LoanerInventoryListPage = ({ defaultFilters }) => {
  const dispatch = useDispatch()
  const [gridData, setGridData] = useState({})
  const [getAPIResults, setGetAPIResult] = useState(null)

  const [hiddenRowKeys, setHiddenRowKeys] = useState([])
  const handleTableChange = (type, { page, sizePerPage }) => {
    const paginationFilters = {
      ...gridData,
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }
  const getData = useCallback(
    (data) => {
      let finalPayload = { ...gridData, ...data, ...defaultFilters }
      setGetAPIResult(null)
      new rest.LoanerInventoryService()
        .makeGetRequest(finalPayload)
        .then((response) => {
          setGetAPIResult(response)
        })
        .catch((errors) => {
          dispatch(
            showErrorToast('Could Not Load  Data.', JSON.stringify(errors))
          )
        })
    },
    [dispatch, gridData, defaultFilters]
  )
  useEffect(() => {
    getData()
  }, [getData, dispatch])
  return !getAPIResults ? (
    <components.Loading />
  ) : (
    <>
      <LoanerInventoryDataGrid
        handleTableChange={handleTableChange}
        onFilter={onFilter}
        getData={getData}
        hiddenRowKeys={hiddenRowKeys}
        results={getAPIResults.results}
        pageSize={getAPIResults.page_size}
        count={getAPIResults.count}
        current={getAPIResults.current}
        onDelete={(item) => {
          getData({})
        }}
      >
        <AddLoanerInventoryPane
          onSubmit={(data) => {
            getData()
          }}
          title="Add Loaner  Inventory"
        />
      </LoanerInventoryDataGrid>
    </>
  )
}
